/**
 * Transforms manage_costs from Key/Value array format to object format
 * Handles both nested array [[{Key, Value}]] and flat array [{Key, Value}] formats
 *
 * @param {Array} manageCosts - The manage_costs array from API
 * @returns {Array} - Transformed array of objects with price, code, type, description, category
 */
export const transformManageCosts = (manageCosts) => {
  // Return empty array if null/undefined/not an array
  if (!Array.isArray(manageCosts) || manageCosts.length === 0) {
    return [];
  }

  // Check if already in correct format (has objects with direct properties)
  const firstItem = manageCosts[0];
  if (firstItem && typeof firstItem === 'object' && !('Key' in firstItem) && !('Value' in firstItem)) {
    return manageCosts; // Already in correct format
  }

  // Handle nested array format: [[{Key, Value}, {Key, Value}, ...]]
  if (Array.isArray(firstItem)) {
    return transformManageCosts(firstItem);
  }

  // Handle Key/Value array format: [{Key, Value}, {Key, Value}, ...]
  if (firstItem && 'Key' in firstItem && 'Value' in firstItem) {
    const costObj = {};
    manageCosts.forEach(kv => {
      if (kv?.Key !== undefined) {
        costObj[kv.Key] = kv.Value;
      }
    });
    return [costObj];
  }

  return [];
};
